
class event {

   constructor(config, reqResult) {
      this.reqResult = reqResult;
      if (config.wm == 'devel') {
         $(document).on("hashchange mobileinit navigate pagebeforechange pagebeforecreate pagebeforehide pagebeforeload pagechangefailed pagecontainerhide pagehide pageremove pagebeforeshow popupafterclose popupafteropen pagecreate", function (e, ui) { //
            console.groupCollapsed(e.type);
            console.log(e, ui);
            console.groupEnd(e.type);
         });
      }
      let self = this;
      $(document).on("pagecontainerload pagecontainerbeforechange pagechange pageinit pageshow popupbeforeposition pageload selectmenucreate pagecontainerbeforeshow pageloadfailed pagecontainerloadfailed popupafterclose", function (e, ui) {
         self[e.type](e, ui, arguments);
      }).on("selectmenucreate", ".filterable-select", function (e) {
         self.selectmenucreate(e);
      });
   }

   pageloadfailed(e, ui) {
      log.error({msg: 'pageloadfailed ', event: e, ui: ui});
   }

   pagecontainerloadfailed(e, ui) {
      log.error({msg: 'pagecontainerloadfailed ', event: e, ui: ui});
   }
   popupafterclose(e, ui) {
      // így a focus out teszi ki a req errort. lehetne a selectHandlerben is
      // ha új ablakba nyílik belefut a selectHandler, az rakj aki az error ha kell de akkor minek a focus out?
      engine.settings.oSel = false;
      engine.resizePageToPopup();
   }
   selectHandler(e, ui) {

      // todo: 2 helyről van hívva.mért?

//      console.log('>> selectHandler', e, ui);

      if (!ui || !('options' in ui) || !ui.absUrl) return;
      //nyit
      if ((ui.options.role == 'popup' || ui.options.role == 'dialog') && ui.options.reverse === false) {
         engine.settings.oSel = false
         var key = ui.absUrl.match("#(.*)-(listbox|dialog)");
         if (key == null || !key[1].length) return;
         engine.settings.oSel = key[1];
         var row = $('#tb_' + key[1]);
//         console.log('>>selectHandler > open: ', key[1], e, ui, row);
         if (!row.length) return 'sopen';
         var d = engine.row[row.data('id')];
         if (d.req) row.hideError();         
         return 'sopen';
      }

      //zár
      if (ui.options.direction == 'back' && ui.options.reverse === true && engine.settings.oSel) {
//         console.log('>>selectHandler > vege', engine.settings.oSel, e, ui);
         var row = $('#tb_' + engine.settings.oSel);
         engine.settings.oSel = false;
         if (!row.length) return;
         row.removeClass('v').addClass('v');
         var d = engine.row[row.data('id')];
         if (!d.req) return;
         var v = row.rVal();
         if (v == null || !v.length || (typeof d.empty != 'undefined' && v == d.empty)) {
            row.showError('req');
            return;
         }
         if (typeof v == 'object' && v.length == 1) {
            if (v[0] == null || !v[0].length || (typeof d.empty != 'undefined' && v[0] == d.empty)) row.showError('req');
         }
      }
      
   }
//   pagebeforecreate(e, ui) {
//      $('#nojs,#nocookie').remove();
//   }
   pagecontainerbeforechange(e, ui) {
      engine.parseCommads();
      this.selectHandler(e, ui);
//      $(window).on("unload", function (event, data) {
//        console.log('data state', data);
//        engine.popMsg('Biztosan elhagyja az oldalt?');
//        e.stopPropagation();
//      });
//      window.onhashchange = function() {
//         console.log('back detect');
//         engine.popMsg('Biztosan elhagyja az oldalt?');
//         e.stopPropagation();
//         return false;
//      }
      $('form').on('submit', function (){
         $('[type="submit"]').button('disable');
         return true;
      });
   }
   pageload(e, ui) {
      $('.ui-page.ui-page-active').remove();
   }
   pageinit(e, ui) {
      $('input,select,textarea').keypress(function (e) {
         return e.keyCode != 13;
      });
      $(document).on('click', 'a.termtaj', function () {
         window.location.href = '//www.clb.hu/termektajekoztato/' + $(this).data().tid+'/228';
      });
      $(document).on('click', 'a.docDisplay', function () {
         window.location.href = '//www.clb.hu/termektajekoztato/' + $(this).data().tid+'/' + $(this).data().did;
      });
      $(".ui-selectmenu .ui-header a.ui-btn").buttonMarkup({icon: 'check'}).prop('title', 'bezár').one('click', function () {
         $(this).parent('.ui-header').find('a').click();
      });
      $('.ui-checkbox a').bind("tap click", function (e) {
         e.stopPropagation();
      });
      
      console.log('----- PAGEINIT engine', $.extend({}, engine));

   }
   pagecontainerload(e, ui) {
      if (ui.xhr.responseText.indexOf('redir|') == 0) {
         $.mobile.ajaxEnabled = false;
         window.location.href = ui.xhr.responseText.split('|')[1];
      }
   }
   pageshow(e) {
      // .help_data,#pop_msg
      $(".ui-popup").popup({history: false});
   }
   pagechange(e, ui) {
      
      if (engine.settings.initRows != engine.settings.pageId) {
         console.log('>>>> pageinit ONCE', engine.settings.initRows, engine.settings.pageId);
         engine.settings.initRows = engine.settings.pageId;

//         if (WM == 'real' && engine.settings.goog.loc != -1) {
//            ga('set', 'location', engine.settings.goog.loc);
//            ga('set', 'userId', engine.settings.pid);
//            ga('send', 'pageview');
//
//            $.each(engine.settings.goog.conv, function (i, l) {
//               engine.fn.gCoversation(l);
//            });
//         }

//            if (engine.settings.goog.loc != -1) {
//                window.dataLayer = window.dataLayer || []; 
//                window.dataLayer.push({'customPagePath': engine.settings.goog.loc});
//                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
//                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
//                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
//                    '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
//                })(window,document,'script','dataLayer',engine.settings.goog.tagManagerId);
//            }

            if (engine.settings.goog.loc != -1) {
               /**
                * elposztolt adatok feltöltése
                * mindent bele kell push-olni a tömbbe a tagManagerId-nek
                */
               window.dataLayer.push({
                  'event': 'pagechange',
                  'url': engine.settings.goog.loc,
                  'engine': engine.settings.engine,
                  'page': engine.settings.pageId,
                  'pid': engine.settings.pid
               });
               
               window.dataLayer = window.dataLayer || [];
               function gtag(){dataLayer.push(arguments);}
               gtag('consent', 'update', {'analytics_storage': 'granted', 'ad_storage': 'granted', 'ad_user_data': 'granted', 'ad_personalization' : 'granted'}); 
               gtag('js', new Date());

               (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({'gtm.start':  new Date().getTime(), event: 'gtm.js'});
                    var f = d.getElementsByTagName(s)[0],j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', engine.settings.goog.tagManagerId);
  
            }
            
         //pageinit korai ezeknek mert nem jelenik meg a force hiba
         $('.ui-header .ui-slider-track').off();
         var id = $("[data-role='page']").data().pageId;
         if (id > engine.oPage) engine.settings.dir = 1;
         else if (id < engine.oPage) engine.settings.dir = -1;
         else engine.settings.dir = 0;
         $('.ui-page-active').data('page', id);
         engine.oPage = id;
         engine.help = {};
         if (!engine.settings.rp) engine.initRows();
         else {
            if (!window.result) {
               this.reqResult();
            } else {
               window.result.setup(engine.settings.result);
               delete(engine.settings.result);
            }
         }

         if (typeof engine.ready != 'undefined') {
            $.each(engine.ready, function (i, fnid) {
               new engine.func({
                  fn: fnid,
                  msg: 'ready',
               }).call();
            });
         }
      }
      this.selectHandler(e, ui);
   }
   popupbeforeposition(e, ui) {
      engine.loadPopup(e, ui);
   }
   selectmenucreate(event) {
      $('.ui-selectmenu .ui-header a.ui-btn').removeClass('ui-btn-left').addClass('ui-btn-right');

      if (!$(event.target).hasClass('filterable-select')) return;
      var input, selectmenu = $(event.target), list = $("#" + selectmenu.attr("id") + "-menu"), form = list.jqmData("filter-form");
//      if (!form) {
         input = $("<input data-type='search'></input>");
         form = $("<form class='msel_search'></form>").append(input);
         input.textinput();
         list.before(form).jqmData("filter-form", form);
         form.jqmData("listview", list);
         $("#" + selectmenu.attr("id") + "-listbox .ui-header").addClass('filterable');
//      }
      selectmenu
         .filterable({
            input: input, 
            children: "> option[value], > optgroup option[value]"
            })
         .on("filterablefilter", function (e) {
            selectmenu.selectmenu("refresh");
         });
   }
   pagecontainerbeforeshow(event, data) {

      // új lapon nyílik
      var listview, form;
      // We only handle the appearance of a dialog generated by a filterable selectmenu
      var isDialog = false,
         id = data.toPage && data.toPage.attr("id");
      $(".filterable-select").each(function () {
         if ($(this).attr("id") + "-dialog" === id) {
            isDialog = true;
            return false;
         }
         });
      if (!isDialog) return;

      $('.ui-selectmenu .ui-header a.ui-btn').removeClass('ui-btn-left').addClass('ui-btn-right');

      $(".ui-selectmenu.ui-dialog .ui-header a").one('click', function () {
         $(".ui-selectmenu.ui-dialog input").val('').trigger('change');
      });

      $(".ui-selectmenu.ui-dialog .ui-header .ui-title").html('RENDBEN / BEZÁR').css('cursor', 'pointer').one('click', function () {
         $(this).parent('.ui-header').find('a').click();
      });
//        if (!engine.pageIsSelectmenuDialog(data.toPage)) {
//               return;
//        }
      listview = data.toPage.find("ul");
      form = listview.jqmData('filter-form');
              // Attach a reference to the listview as a data item to the dialog, because during the
              // pagecontainerhide handler below the selectmenu widget will already have returned the
              // listview to the popup, so we won't be able to find it inside the dialog with a selector.
            data.toPage.jqmData("listview", listview);
              // Place the form before the listview in the dialog.
            listview.before(form);

      $(data.toPage).find('.ui-header').addClass('filterable');
   }
}

export default event